// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-filter-bar {
  height: auto;
  min-height: 80px;
  background-color: #2a2a2a;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 10px;
  border-radius: 10px 10px 0px 0px;
  margin-right: 5px;
}

.location-platform-buttons {
  display: flex;
  gap: 10px;
}

.location-platform-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 2px solid #65ccb7;
  background: transparent;
  color: white;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.location-platform-btn:hover, .location-platform-btn.active {
  background: #65ccb7;
}

.location-filter-select-container {
  position: relative;
  min-width: 200px;
}

.location-custom-select {
  position: relative;
  width: 100%;
}

.location-select-header {
  padding: 8px;
  border-radius: 4px;
  background: #3a3a3a;
  color: white;
  border: 1px solid #65ccb7;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.location-select-header span {
  margin-right: 10px;
}

.location-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #3a3a3a;
  border: 1px solid #65ccb7;
  border-radius: 4px;
  margin-top: 4px;
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
}

.location-select-search {
  padding: 8px;
  width: 100%;
  background: #2a2a2a;
  color: white;
  border: none;
  border-bottom: 1px solid #65ccb7;
}

.location-select-options {
  max-height: 250px;
  overflow-y: auto;
}

.location-select-option {
  padding: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.location-select-option:hover {
  background-color: #4a4a4a;
}

.location-select-option.selected {
  background-color: #65ccb7;
  color: white;
}

.location-date-filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.location-date-picker {
  padding: 8px;
  border-radius: 4px;
  background: #3a3a3a;
  color: white;
  border: 1px solid #65ccb7;
}

 .location-search-container {
  display: flex;
  gap: 10px;
  flex: 1 1;
  min-width: 200px;
} 

.location-search-input {
  flex: 1 1;
  padding: 8px;
  border-radius: 4px;
  background: #3a3a3a;
  color: white;
  border: 1px solid #65ccb7;
} 

.location-search-btn, .location-reset-btn {
  padding: 8px 16px;
  border: none;
  background: #65ccb7;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: auto;
}

.location-search-btn:hover, .location-reset-btn:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .location-filter-bar {
    padding: 10px;
    gap: 10px;
  }

  .location-platform-buttons,
  .location-filter-select-container,
  .location-date-filters,
  .location-search-container {
    width: 100%;
  }

  .location-date-filters {
    flex-direction: column;
  }

  .location-date-picker {
    width: 100%;
  }
}
.location-filter-bar h3 {
  color: #fff;
  margin-bottom: 10px;
}
.location-search-container-main {
  display: flex;
  flex-direction: column;
  align-items: center; /* Centers the content vertically and horizontally in a flex column */
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/globe/components/FilterBar/FilterBar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;CAEC;EACC,aAAa;EACb,SAAS;EACT,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,qEAAqE;EAC1F,uBAAuB;AACzB","sourcesContent":[".location-filter-bar {\n  height: auto;\n  min-height: 80px;\n  background-color: #2a2a2a;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n  border-radius: 10px 10px 0px 0px;\n  margin-right: 5px;\n}\n\n.location-platform-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.location-platform-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border: 2px solid #65ccb7;\n  background: transparent;\n  color: white;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.location-platform-btn:hover, .location-platform-btn.active {\n  background: #65ccb7;\n}\n\n.location-filter-select-container {\n  position: relative;\n  min-width: 200px;\n}\n\n.location-custom-select {\n  position: relative;\n  width: 100%;\n}\n\n.location-select-header {\n  padding: 8px;\n  border-radius: 4px;\n  background: #3a3a3a;\n  color: white;\n  border: 1px solid #65ccb7;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.location-select-header span {\n  margin-right: 10px;\n}\n\n.location-select-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: #3a3a3a;\n  border: 1px solid #65ccb7;\n  border-radius: 4px;\n  margin-top: 4px;\n  z-index: 1000;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.location-select-search {\n  padding: 8px;\n  width: 100%;\n  background: #2a2a2a;\n  color: white;\n  border: none;\n  border-bottom: 1px solid #65ccb7;\n}\n\n.location-select-options {\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.location-select-option {\n  padding: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.location-select-option:hover {\n  background-color: #4a4a4a;\n}\n\n.location-select-option.selected {\n  background-color: #65ccb7;\n  color: white;\n}\n\n.location-date-filters {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.location-date-picker {\n  padding: 8px;\n  border-radius: 4px;\n  background: #3a3a3a;\n  color: white;\n  border: 1px solid #65ccb7;\n}\n\n .location-search-container {\n  display: flex;\n  gap: 10px;\n  flex: 1;\n  min-width: 200px;\n} \n\n.location-search-input {\n  flex: 1;\n  padding: 8px;\n  border-radius: 4px;\n  background: #3a3a3a;\n  color: white;\n  border: 1px solid #65ccb7;\n} \n\n.location-search-btn, .location-reset-btn {\n  padding: 8px 16px;\n  border: none;\n  background: #65ccb7;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: auto;\n}\n\n.location-search-btn:hover, .location-reset-btn:hover {\n  opacity: 0.8;\n  transform: scale(1.05);\n}\n\n@media (max-width: 768px) {\n  .location-filter-bar {\n    padding: 10px;\n    gap: 10px;\n  }\n\n  .location-platform-buttons,\n  .location-filter-select-container,\n  .location-date-filters,\n  .location-search-container {\n    width: 100%;\n  }\n\n  .location-date-filters {\n    flex-direction: column;\n  }\n\n  .location-date-picker {\n    width: 100%;\n  }\n}\n.location-filter-bar h3 {\n  color: #fff;\n  margin-bottom: 10px;\n}\n.location-search-container-main {\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* Centers the content vertically and horizontally in a flex column */\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
